import * as React from 'react';
import {
  WorkHistoryNode,
  WorkHistoryCall,
  RetailerNode,
  CallStatusEnum,
} from '../../../schema';
import { Card, Row, Col, Button, Modal, Page, notify } from 'sha-el-design';
import { ActiveCall } from './ActiveCall';
import { EditRetailer } from './EditRetailer';
import { Link } from 'react-router-dom';
import { MdArrowBack, MdHome } from 'react-icons/md';
import './callingStyles';

export class RetailerCallDetail extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      calls: this.props.work.calls,
      activeCall: this.getActiveRetailer(),
      isAlternateNumberActive: false,
      isCallActive: false,
      showModal: false,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({ activeCall: this.getActiveRetailer(nextProps) });
  }

  // NOTE: this previously read `v.callStatus === null || CallStatusEnum.NO_REPLY`.
  // Operator precedence made that `(v.callStatus === null) || "NO_REPLY"` -- the
  // right-hand side is a non-empty string constant, so the predicate was ALWAYS
  // true and find() always returned calls[0] regardless of its status. The queue
  // only advanced because the mutation handlers splice the finished entry out and
  // push it to the end; any flow that updated `calls` without reordering left the
  // caller pinned on the same retailer. That is the "call stuck" bug.
  getActiveRetailer = (props = this.props) => {
    return props.work.calls.find(
      (v) => v.callStatus === null || v.callStatus === CallStatusEnum.NO_REPLY,
    );
  }

  getNumberColor = (retailer: RetailerNode, mobilenumber: string) => {
    return (retailer.numberInDnd || []).includes(mobilenumber) ? 'red' : 'black';
  }

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  breadcrumbs = () => ({
    seperator: '/',
    paths: [
      { text: <MdHome />, link: '/dashboard' },
      { text: 'Start Calling', link: '/dashboard/start_calling' },
      { text: 'Active Work', link: '/dashboard/start_calling/active' },
    ].map((v) => ({
      render: () => (
        <Link key={v.link} to={v.link}>
          {v.text}
        </Link>
      ),
    })),
  })

  postWrongNumberOnCloseRetailer = (toCloseRetailer: string) => {
    this.props.toggleLoading(true);
    const { isAlternateNumberActive, activeCall } = this.state;
    if (activeCall.retailer.mobilenumber2 && !isAlternateNumberActive) {
      this.props.onWrongNumber(activeCall, isAlternateNumberActive, toCloseRetailer);
      this.setState({ isAlternateNumberActive: true }, () => {
        this.props.toggleLoading(false);
        notify({
          type: 'info',
          title: 'Moving to next Retailer',
          message: 'Marked as Wrong Number',
          callBack: () => {
            this.props.onWrongNumber(activeCall, this.state.isAlternateNumberActive, toCloseRetailer);
            this.setState({ isAlternateNumberActive: false });
          },
        });
      });
      return;
    }
    else if (!activeCall.retailer.mobilenumber2) {
      return notify({
        type: 'info',
        title: 'Moving to next Retailer',
        message: 'Marked as Wrong Number',
        callBack: () => this.props.onWrongNumber(activeCall, this.state.isAlternateNumberActive, toCloseRetailer),
      });
    }
  }

  render() {
    const { isAlternateNumberActive, activeCall, isCallActive, showModal } = this.state;
    // When every entry has a terminal status (ANSWERED / REJECTED /
    // WRONG_NUMBER, no NO_REPLY left to retry), getActiveRetailer finds
    // nothing and activeCall is undefined. The destructure below then threw
    // -- a white screen at the exact moment the caller completed their queue,
    // BEFORE they could press Finish Work. Render a completion panel instead;
    // the Finish/On-Hold controls live in WorkCompletionStatus alongside.
    if (!activeCall) {
      return (
        <Page
          title={'Active Work'}
          breadcrumbs={this.breadcrumbs()}
          backIcon={
            <Link to={'/dashboard/start_calling'}>
              <MdArrowBack />
            </Link>
          }
        >
          <Card>
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <h3 style={{ margin: '0 0 8px' }}>All retailers processed</h3>
              <p style={{ margin: 0, color: '#666' }}>
                Every retailer in this list has an outcome. Use <b>Finish Work</b> to
                complete the allocation, or <b>Set To On Hold</b> to pause it.
              </p>
            </div>
          </Card>
        </Page>
      );
    }
    const { retailer } = activeCall;
    return (
      <>
        <Page
          title={'Active Work'}
          breadcrumbs={this.breadcrumbs()}
          backIcon={
            <Link to={'/dashboard/start_calling'}>
              <MdArrowBack />
            </Link>
          }
        >
          <Card
            footer={
              <Row>
                <Col span={3} offset={16}>
                  <Button onClick={this.toggleModal} type='primary' disabled={this.props.isEditRetailerDisabled}>
                    Edit
                  </Button>
                  <Modal
                    title='Edit Retailer'
                    isVisible={showModal}
                    onClose={this.toggleModal}
                  >
                    <EditRetailer
                      retailer={retailer}
                      toggleModal={this.toggleModal}
                      postWrongNumberOnCloseRetailer={this.postWrongNumberOnCloseRetailer}
                    />
                  </Modal>
                </Col>
                <Col span={5}>
                  <Button
                    onClick={() => this.setState({ isCallActive: true })}
                    type='primary'
                    disabled={isCallActive}
                  >
                    Start Calling
                  </Button>
                </Col>
              </Row>
            }
          >
            {/* The identity used to be a generic two-column label/value grid,
                which gave "Class" the same weight as the phone number -- the
                one thing the caller actually needs. Firm leads; the numbers
                are tiles. */}
            <div className='cs-call cs-call__retailer'>
              <div>
                <h2 className='cs-call__firm'>{retailer.firm}</h2>
                <p className='cs-call__sub'>{retailer.proprietor}</p>
              </div>

              <div className='cs-call__meta'>
                <span className='cs-call__tag'>
                  {retailer.areaid
                    ? `${retailer.townid.name} / ${retailer.areaid.name}`
                    : retailer.townid.name}
                </span>
                {retailer.classField ? (
                  <span className='cs-call__tag'>Class {retailer.classField}</span>
                ) : null}
                {retailer.address ? <span className='cs-call__tag'>{retailer.address}</span> : null}
              </div>

              <div className='cs-call__phones'>
                {(() => {
                  const dnd1 = this.getNumberColor(retailer, retailer.mobilenumber1) === 'red';
                  const primaryLive = !isAlternateNumberActive;
                  return (
                    <div
                      className={
                        'cs-call__phone' +
                        (primaryLive ? ' cs-call__phone--active' : ' cs-call__phone--idle') +
                        (dnd1 ? ' cs-call__phone--dnd' : '')
                      }
                    >
                      <span>
                        <span className='cs-call__phone-label'>Primary</span>
                        <span className='cs-call__phone-number'>{retailer.mobilenumber1 || '--'}</span>
                      </span>
                      <span className={`cs-call__badge cs-call__badge--${dnd1 ? 'dnd' : primaryLive ? 'live' : 'none'}`}>
                        {dnd1 ? 'DND' : primaryLive ? 'Calling' : 'Idle'}
                      </span>
                    </div>
                  );
                })()}
                {(() => {
                  // BUG-05: the alternate used to be coloured by the PRIMARY
                  // number's DND status, so a caller could dial a DND-listed
                  // alternate believing it clean -- a compliance exposure. It
                  // also painted black text on a black background while
                  // inactive, making the number invisible.
                  const has2 = !!retailer.mobilenumber2;
                  const dnd2 = has2 && this.getNumberColor(retailer, retailer.mobilenumber2) === 'red';
                  return (
                    <div
                      className={
                        'cs-call__phone' +
                        (isAlternateNumberActive ? ' cs-call__phone--active' : ' cs-call__phone--idle') +
                        (dnd2 ? ' cs-call__phone--dnd' : '')
                      }
                    >
                      <span>
                        <span className='cs-call__phone-label'>Alternate</span>
                        <span className='cs-call__phone-number'>{retailer.mobilenumber2 || 'None'}</span>
                      </span>
                      <span
                        className={
                          'cs-call__badge cs-call__badge--' +
                          (dnd2 ? 'dnd' : isAlternateNumberActive ? 'live' : 'none')
                        }
                      >
                        {dnd2 ? 'DND' : isAlternateNumberActive ? 'Calling' : has2 ? 'Idle' : 'N/A'}
                      </span>
                    </div>
                  );
                })()}
              </div>
            </div>
          </Card>
        </Page>
        {isCallActive && (
          <ActiveCall
            isAlternateNumberActive={isAlternateNumberActive}
            call={activeCall}
            onNoAnswer={(secondNumber) =>
              this.props.onNoAnswer(activeCall, secondNumber)
            }
            onAnswer={(secondNumber) =>
              this.props.onAnswer(activeCall, secondNumber)
            }
            onWrongNumber={(secondNumber) =>
              this.props.onWrongNumber(activeCall, secondNumber, 'No')
            }
            onReject={() => this.props.onReject(activeCall)}
            activateAlternateNumber={() =>
              this.setState({ isAlternateNumberActive: true })
            }
            deactivateAlternateNumber={() =>
              this.setState({ isAlternateNumberActive: false })
            }
          />
        )}
      </>
    );
  }
}

interface Props {
  work: WorkHistoryNode;
  onNoAnswer: (
    activeCall: WorkHistoryCall,
    isAlternateNumberActive: boolean,
  ) => void;
  onAnswer: (
    activeCall: WorkHistoryCall,
    isAlternateNumberActive: boolean,
  ) => void;
  onWrongNumber: (
    activeCall: WorkHistoryCall,
    isAlternateNumberActive: boolean,
    toCloseRetailer: string,
  ) => void;
  onReject: (activeCall: WorkHistoryCall) => void;
  toggleLoading: (hasLoading: boolean) => void;
  isEditRetailerDisabled: boolean;
}

interface State {
  activeCall: WorkHistoryCall;
  isAlternateNumberActive: boolean;
  calls: WorkHistoryCall[];
  isCallActive: boolean;
  showModal: boolean;
}
